import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.graph');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Network, DataSet } from 'vis-network/standalone';

@Component({
    selector: 'wiz-page-graph',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.graph/view.scss */
/* Expected identifier.
   ╷
72 │ canvas[#minimapCanvas] {
   │        ^
   ╵
  src/app/page.graph/view.scss 72:8  root stylesheet */`],
})
export class PageGraphComponent implements OnInit, OnDestroy {
    @ViewChild('graphContainer') graphContainer: ElementRef;
    @ViewChild('chatMessagesContainer') chatMessagesContainer: ElementRef;
    @ViewChild('minimapCanvas') minimapCanvasRef: ElementRef;

    public collections: any[] = [];
    public selectedCollection: string = '';
    public extractTypes: any = { person: true, place: true, event: true, date: false };
    public nodes: any[] = [];
    public edges: any[] = [];
    public selectedNode: any = null;
    public connectedEdges: any[] = [];
    public nodeDocs: any[] = [];
    public nodeDocsLoading: boolean = false;
    public loading: boolean = true;
    public graphLoading: boolean = false;
    public building: boolean = false;
    public buildMessage: string = '';
    public buildElapsed: number = 0;
    public buildProgress: string = '';
    public buildProgressPct: number = 0;
    public buildNodeCount: number = 0;
    public buildEdgeCount: number = 0;
    public reviewCount: number = 0;

    // 우측 패널
    public rightTab: string = 'detail';
    public panelCollapsed: boolean = false;

    // 캔버스 컨트롤
    public isFullscreen: boolean = false;

    // 노드 검색
    public nodeSearch: string = '';
    public nodeSearchResults: any[] = [];
    public showNodeSearch: boolean = false;

    // 그래프/테이블/타임라인 뷰
    public graphViewMode: string = 'graph';
    public tableSortBy: string = 'label';
    public tableSortDir: string = 'asc';
    public tableFilterType: string = '';

    // 인터랙티브 범례
    public highlightType: string = '';

    // 포커스 모드
    public focusMode: boolean = true;

    // 노드 편집
    public editingNode: boolean = false;
    public editForm: any = { label: '', node_type: '', description: '' };

    // 노드 병합
    public mergeMode: boolean = false;
    public mergeTarget: any = null;

    // 레이아웃
    public graphLayout: string = 'force';

    // 엣지 라벨
    public showEdgeLabels: boolean = true;

    // 중심성 (허브)
    public hubScores: any = {};

    // 문서 필터
    public docFilters: any[] = [];
    public docFilterOpen: boolean = false;

    // 비교 모드
    public compareMode: boolean = false;
    public compareCollection: string = '';
    public compareResult: any = null;

    // 미니맵
    public showMinimap: boolean = true;
    private minimapTransform: any = null;
    private minimapTimeout: any = null;

    // 채팅
    public chatMessages: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;
    public chatExamples: string[] = [
        '이 자료함에서 가장 많이 언급된 지명은?',
        '두 문서의 공통 주제는 무엇인가요?',
        '핵심 인물 간의 관계를 설명해줘'
    ];

    private network: any = null;
    private visNodes: any = null;
    private visEdges: any = null;
    private originalColors: Map<string, any> = new Map();

    private nodeColorMap: any = {
        person: { background: '#93c5fd', border: '#60a5fa', highlight: { background: '#bfdbfe', border: '#60a5fa' }, hover: { background: '#bfdbfe', border: '#60a5fa' } },
        place: { background: '#6ee7b7', border: '#34d399', highlight: { background: '#a7f3d0', border: '#34d399' }, hover: { background: '#a7f3d0', border: '#34d399' } },
        event: { background: '#fda4af', border: '#fb7185', highlight: { background: '#fecdd3', border: '#fb7185' }, hover: { background: '#fecdd3', border: '#fb7185' } },
        date: { background: '#c4b5fd', border: '#a78bfa', highlight: { background: '#ddd6fe', border: '#a78bfa' }, hover: { background: '#ddd6fe', border: '#a78bfa' } }
    };

    private getNodeVisData(n: any, size?: number) {
        const nodeSize = size || (18 + (this.getEdgeCount(n.id) * 3));
        const isHubNode = this.isHub(n.id);
        const label = n.label.length > 8 ? n.label.substring(0, 7) + '…' : n.label;
        return {
            id: n.id,
            label: label,
            group: n.node_type,
            color: this.nodeColorMap[n.node_type] || this.nodeColorMap.event,
            font: { color: '#1c1917', size: isHubNode ? 12 : 10, face: 'Pretendard, sans-serif', vadjust: 0, bold: isHubNode ? { color: '#0c0a09' } : undefined },
            shape: 'circle',
            size: isHubNode ? nodeSize + 6 : nodeSize,
            title: n.label + (n.metadata?.description ? ' — ' + n.metadata.description : ''),
            borderWidth: isHubNode ? 3 : 2
        };
    }

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");

        this.route.queryParams.subscribe(async (params: any) => {
            if (params.collection) {
                this.selectedCollection = params.collection;
            }
        });

        await this.loadCollections();
    }

    ngOnDestroy() {
        if (this.network) {
            this.network.destroy();
            this.network = null;
        }
    }

    // ===== Collections =====
    public async loadCollections() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("collections");
        if (code === 200) {
            this.collections = data.collections || [];
        }

        if (this.selectedCollection) {
            await this.loadGraph();
        }

        this.loading = false;
        await this.service.render();
    }

    public async selectCollection(id: string) {
        this.selectedCollection = id;
        this.selectedNode = null;
        this.connectedEdges = [];
        this.highlightType = '';
        this.docFilters = [];
        this.docFilterOpen = false;
        this.mergeMode = false;
        this.mergeTarget = null;
        this.editingNode = false;

        // 진행 중인 채팅 스트림 취소
        if (this.chatAbortController) {
            this.chatAbortController.abort();
            this.chatAbortController = null;
        }
        this.chatLoading = false;
        this.chatMessages = [];

        if (this.network) {
            this.network.destroy();
            this.network = null;
        }
        this.visNodes = null;
        this.visEdges = null;
        this.nodes = [];
        this.edges = [];

        this.updateChatExamples();
        await this.loadGraph();
        await this.service.render();
    }

    // ===== Graph Loading =====
    public async loadGraph() {
        if (!this.selectedCollection) return;
        this.graphLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call("graph_data", {
            collection_id: this.selectedCollection
        });

        if (code === 200) {
            this.nodes = data.nodes || [];
            this.edges = data.edges || [];
            this.reviewCount = data.review_count || 0;
        }

        this.calculateHubScores();
        this.graphLoading = false;
        await this.service.render();

        setTimeout(() => this.renderGraph(), 100);

        if (this.nodes.length > 0) {
            this.loadDocFilters();
        }
    }

    // ===== Document Filter =====
    private async loadDocFilters() {
        try {
            const { code, data } = await wiz.call("doc_filter_data", {
                collection_id: this.selectedCollection
            });
            if (code === 200) {
                this.docFilters = (data.documents || []).map((d: any) => ({
                    ...d,
                    enabled: true
                }));
            }
        } catch (e) { }
        await this.service.render();
    }

    public async toggleDocFilterOpen() {
        this.docFilterOpen = !this.docFilterOpen;
        await this.service.render();
    }

    public async closeDocFilter() {
        this.docFilterOpen = false;
        await this.service.render();
    }

    public async toggleDocFilter(index: number) {
        this.docFilters[index].enabled = !this.docFilters[index].enabled;
        this.applyAllFilters();
        await this.service.render();
    }

    public async toggleAllDocFilters(enable: boolean) {
        for (const df of this.docFilters) {
            df.enabled = enable;
        }
        this.applyAllFilters();
        await this.service.render();
    }

    private applyAllFilters() {
        if (!this.visNodes || !this.visEdges) return;

        // 1. 엔티티 타입 필터: 활성 타입의 노드 ID 수집
        const typeVisibleIds = new Set<string>();
        for (const n of this.nodes) {
            if (this.extractTypes[n.node_type]) {
                typeVisibleIds.add(n.id);
            }
        }

        // 2. 문서 필터: 활성 문서의 노드 ID 수집
        let docVisibleIds: Set<string> | null = null;
        if (this.docFilters.length > 0) {
            const allEnabled = this.docFilters.every((d: any) => d.enabled);
            const noneEnabled = this.docFilters.every((d: any) => !d.enabled);

            if (!allEnabled && !noneEnabled) {
                docVisibleIds = new Set<string>();
                const allMappedNodeIds = new Set<string>();
                for (const df of this.docFilters) {
                    for (const nid of df.node_ids) {
                        allMappedNodeIds.add(nid);
                    }
                }
                for (const df of this.docFilters) {
                    if (df.enabled) {
                        for (const nid of df.node_ids) {
                            docVisibleIds.add(nid);
                        }
                    }
                }
                // 어느 문서에도 매핑되지 않은 노드는 항상 표시
                for (const n of this.nodes) {
                    if (!allMappedNodeIds.has(n.id)) {
                        docVisibleIds.add(n.id);
                    }
                }
            }
        }

        // 3. 두 필터 모두 통과해야 표시
        const visibleNodeIds = new Set<string>();
        const nodeUpdates: any[] = [];
        for (const n of this.nodes) {
            const typeOk = typeVisibleIds.has(n.id);
            const docOk = docVisibleIds === null || docVisibleIds.has(n.id);
            const visible = typeOk && docOk;

            if (visible) {
                visibleNodeIds.add(n.id);
                const visData = this.getNodeVisData(n);
                nodeUpdates.push({ id: n.id, hidden: false, color: visData.color, font: visData.font });
            } else {
                nodeUpdates.push({ id: n.id, hidden: true });
            }
        }
        this.visNodes.update(nodeUpdates);

        // 4. 엣지: 양쪽 노드가 모두 표시될 때만 표시
        const edgeUpdates: any[] = [];
        for (const e of this.edges) {
            const hidden = !visibleNodeIds.has(e.source_id) || !visibleNodeIds.has(e.target_id);
            edgeUpdates.push({ id: e.id, hidden });
        }
        this.visEdges.update(edgeUpdates);
    }

    public getDocFilterActiveCount(): number {
        if (!this.docFilters.length) return 0;
        return this.docFilters.filter((d: any) => d.enabled).length;
    }

    // ===== Canvas Controls =====
    public async zoomIn() {
        if (!this.network) return;
        const scale = this.network.getScale();
        this.network.moveTo({ scale: scale * 1.3, animation: { duration: 300 } });
    }

    public async zoomOut() {
        if (!this.network) return;
        const scale = this.network.getScale();
        this.network.moveTo({ scale: scale / 1.3, animation: { duration: 300 } });
    }

    public async fitGraph() {
        if (!this.network) return;
        this.network.fit({ animation: { duration: 500 } });
    }

    public async toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
        await this.service.render();
        if (this.network) {
            setTimeout(() => this.network.redraw(), 100);
        }
    }

    public async togglePanel() {
        this.panelCollapsed = !this.panelCollapsed;
        await this.service.render();
        if (this.network) {
            setTimeout(() => this.network.redraw(), 300);
        }
    }

    // ===== Node Search =====
    public async onNodeSearch() {
        const q = this.nodeSearch.trim().toLowerCase();
        if (!q) {
            this.nodeSearchResults = [];
            this.showNodeSearch = false;
            await this.service.render();
            return;
        }
        this.nodeSearchResults = this.nodes
            .filter((n: any) => n.label.toLowerCase().includes(q))
            .slice(0, 10);
        this.showNodeSearch = this.nodeSearchResults.length > 0;
        await this.service.render();
    }

    public async selectSearchResult(node: any) {
        this.nodeSearch = '';
        this.showNodeSearch = false;
        this.nodeSearchResults = [];
        this.graphViewMode = 'graph';
        await this.service.render();
        setTimeout(async () => {
            await this.focusNode(node.id);
        }, 100);
    }

    public async closeNodeSearch() {
        this.showNodeSearch = false;
        await this.service.render();
    }

    public onSearchBlur() {
        setTimeout(() => this.closeNodeSearch(), 200);
    }

    // ===== Graph / Table / Timeline View =====
    public async switchGraphView(mode: string) {
        this.graphViewMode = mode;
        await this.service.render();
        if (mode === 'graph' && this.nodes.length > 0) {
            setTimeout(() => {
                this.renderGraph();
            }, 100);
        }
    }

    public get sortedTableNodes(): any[] {
        let result = [...this.nodes];
        if (this.tableFilterType) {
            result = result.filter((n: any) => n.node_type === this.tableFilterType);
        }
        result.sort((a: any, b: any) => {
            let va: any, vb: any;
            if (this.tableSortBy === 'label') {
                va = a.label || '';
                vb = b.label || '';
            } else if (this.tableSortBy === 'type') {
                va = a.node_type || '';
                vb = b.node_type || '';
            } else if (this.tableSortBy === 'edges') {
                va = this.getEdgeCount(a.id);
                vb = this.getEdgeCount(b.id);
            } else if (this.tableSortBy === 'confidence') {
                va = a.confidence || 0;
                vb = b.confidence || 0;
            } else {
                va = a.label || '';
                vb = b.label || '';
            }
            if (typeof va === 'string') {
                const cmp = va.localeCompare(vb);
                return this.tableSortDir === 'asc' ? cmp : -cmp;
            }
            return this.tableSortDir === 'asc' ? va - vb : vb - va;
        });
        return result;
    }

    public async setTableSort(col: string) {
        if (this.tableSortBy === col) {
            this.tableSortDir = this.tableSortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.tableSortBy = col;
            this.tableSortDir = col === 'edges' || col === 'confidence' ? 'desc' : 'asc';
        }
        await this.service.render();
    }

    public async setTableFilter(type: string) {
        this.tableFilterType = this.tableFilterType === type ? '' : type;
        await this.service.render();
    }

    // ===== Timeline =====
    public get timelineData(): any[] {
        const dateNodes = this.nodes
            .filter((n: any) => n.node_type === 'date')
            .sort((a: any, b: any) => this.extractYear(a.label) - this.extractYear(b.label));

        return dateNodes.map((dateNode: any) => {
            const connected = this.edges
                .filter((e: any) => e.source_id === dateNode.id || e.target_id === dateNode.id)
                .map((e: any) => {
                    const otherId = e.source_id === dateNode.id ? e.target_id : e.source_id;
                    const otherNode = this.nodes.find((n: any) => n.id === otherId);
                    return { edge: e, otherNode };
                })
                .filter((item: any) => item.otherNode);
            return { dateNode, connected };
        });
    }

    private extractYear(label: string): number {
        const match = label.match(/(\d{3,4})/);
        return match ? parseInt(match[1]) : 9999;
    }

    // ===== Interactive Legend =====
    public async toggleHighlightType(type: string) {
        if (this.highlightType === type) {
            this.highlightType = '';
            this.restoreAllNodeColors();
        } else {
            this.highlightType = type;
            this.highlightNodesByType(type);
        }
        await this.service.render();
    }

    private highlightNodesByType(type: string) {
        if (!this.visNodes) return;
        const allNodes = this.visNodes.get();
        const updates: any[] = [];
        for (const n of allNodes) {
            if (!this.originalColors.has(n.id)) {
                this.originalColors.set(n.id, { color: n.color, font: { ...n.font } });
            }
            const node = this.nodes.find((nd: any) => nd.id === n.id);
            if (node && node.node_type === type) {
                updates.push({
                    id: n.id,
                    color: this.nodeColorMap[type] || this.nodeColorMap.event,
                    font: { ...n.font, color: '#1c1917' }
                });
            } else {
                updates.push({
                    id: n.id,
                    color: { background: '#e7e5e4', border: '#d6d3d1', highlight: { background: '#e7e5e4', border: '#d6d3d1' }, hover: { background: '#e7e5e4', border: '#d6d3d1' } },
                    font: { ...n.font, color: '#a8a29e' }
                });
            }
        }
        this.visNodes.update(updates);
    }

    private restoreAllNodeColors() {
        if (!this.visNodes) return;
        const updates: any[] = [];
        for (const n of this.nodes) {
            const orig = this.originalColors.get(n.id);
            if (orig) {
                updates.push({ id: n.id, color: orig.color, font: orig.font });
            } else {
                updates.push(this.getNodeVisData(n));
            }
        }
        this.visNodes.update(updates);
        this.originalColors.clear();
    }

    public getTypeCount(type: string): number {
        return this.nodes.filter((n: any) => n.node_type === type).length;
    }

    public getTypePct(type: string): number {
        if (this.nodes.length === 0) return 0;
        return Math.round((this.getTypeCount(type) / this.nodes.length) * 100);
    }

    // ===== Focus Mode (1-hop highlight) =====
    private applyFocusMode(nodeId: string) {
        if (!this.focusMode || !this.visNodes || !this.visEdges) return;

        const connectedNodeIds = new Set<string>();
        connectedNodeIds.add(nodeId);
        for (const e of this.edges) {
            if (e.source_id === nodeId) connectedNodeIds.add(e.target_id);
            if (e.target_id === nodeId) connectedNodeIds.add(e.source_id);
        }

        const nodeUpdates: any[] = [];
        for (const n of this.nodes) {
            if (!this.originalColors.has(n.id)) {
                const current = this.visNodes.get(n.id);
                if (current) this.originalColors.set(n.id, { color: current.color, font: { ...current.font } });
            }
            if (connectedNodeIds.has(n.id)) {
                nodeUpdates.push({
                    id: n.id,
                    color: this.nodeColorMap[n.node_type] || this.nodeColorMap.event,
                    font: { color: '#1c1917', size: 11, face: 'Pretendard, sans-serif', vadjust: 0 }
                });
            } else {
                nodeUpdates.push({
                    id: n.id,
                    color: { background: '#f5f5f4', border: '#e7e5e4', highlight: { background: '#f5f5f4', border: '#e7e5e4' }, hover: { background: '#f5f5f4', border: '#e7e5e4' } },
                    font: { color: '#d6d3d1', size: 11, face: 'Pretendard, sans-serif', vadjust: 0 }
                });
            }
        }
        this.visNodes.update(nodeUpdates);

        const edgeUpdates: any[] = [];
        for (const e of this.edges) {
            const connected = (e.source_id === nodeId || e.target_id === nodeId);
            edgeUpdates.push({
                id: e.id,
                color: connected ? { color: '#78716c', highlight: '#44403c', hover: '#57534e' } : { color: '#f5f5f4', highlight: '#f5f5f4', hover: '#f5f5f4' },
                font: { size: connected && this.showEdgeLabels ? 10 : 0, color: connected ? '#78716c' : 'transparent', strokeWidth: 0, face: 'Pretendard, sans-serif' },
                width: connected ? 2 : 0.5
            });
        }
        this.visEdges.update(edgeUpdates);
    }

    private clearFocusMode() {
        if (!this.visNodes || !this.visEdges) return;
        this.restoreAllNodeColors();

        const edgeUpdates: any[] = [];
        for (const e of this.edges) {
            edgeUpdates.push({
                id: e.id,
                color: { color: '#d6d3d1', highlight: '#78716c', hover: '#a8a29e' },
                font: { size: this.showEdgeLabels ? 10 : 0, color: '#a8a29e', strokeWidth: 0, face: 'Pretendard, sans-serif' },
                width: 1.5
            });
        }
        this.visEdges.update(edgeUpdates);
    }

    // ===== Node Editing =====
    public async startEditNode() {
        if (!this.selectedNode) return;
        this.editForm = {
            label: this.selectedNode.label,
            node_type: this.selectedNode.node_type,
            description: this.selectedNode.metadata?.description || ''
        };
        this.editingNode = true;
        await this.service.render();
    }

    public async cancelEditNode() {
        this.editingNode = false;
        await this.service.render();
    }

    public async saveNodeEdit() {
        const { code } = await wiz.call("edit_node", {
            node_id: this.selectedNode.id,
            label: this.editForm.label,
            node_type: this.editForm.node_type,
            description: this.editForm.description
        });
        if (code === 200) {
            this.editingNode = false;
            this.selectedNode = null;
            this.connectedEdges = [];
            await this.loadGraph();
        }
        await this.service.render();
    }

    public async deleteNode() {
        const confirmed = await this.service.modal.show({
            title: '노드 삭제',
            message: `'${this.selectedNode.label}' 노드와 연결된 모든 관계를 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call("delete_node", {
            node_id: this.selectedNode.id,
            collection_id: this.selectedCollection
        });
        if (code === 200) {
            this.selectedNode = null;
            this.connectedEdges = [];
            this.nodeDocs = [];
            await this.loadGraph();
        }
        await this.service.render();
    }

    // ===== Node Merge =====
    public async startMerge() {
        if (!this.selectedNode) return;
        this.mergeMode = true;
        this.mergeTarget = this.selectedNode;
        await this.service.render();
    }

    public async cancelMerge() {
        this.mergeMode = false;
        this.mergeTarget = null;
        await this.service.render();
    }

    public async confirmMerge(targetNodeId: string) {
        if (!this.mergeTarget || this.mergeTarget.id === targetNodeId) return;

        const targetNode = this.nodes.find((n: any) => n.id === targetNodeId);
        const confirmed = await this.service.modal.show({
            title: '노드 병합',
            message: `'${this.mergeTarget.label}'의 모든 관계를 '${targetNode?.label}'(으)로 이전하고 삭제합니다.`,
            action: '병합',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call("merge_nodes", {
            source_id: this.mergeTarget.id,
            target_id: targetNodeId,
            collection_id: this.selectedCollection
        });
        if (code === 200) {
            this.mergeMode = false;
            this.mergeTarget = null;
            this.selectedNode = null;
            this.connectedEdges = [];
            await this.loadGraph();
        }
        await this.service.render();
    }

    // ===== Graph Export =====
    public exportGraph() {
        if (!this.network || !this.graphContainer?.nativeElement) return;
        const canvas = this.graphContainer.nativeElement.querySelector('canvas');
        if (!canvas) return;

        const link = document.createElement('a');
        const title = this.getCollectionTitle(this.selectedCollection) || 'graph';
        link.download = `관계지도_${title}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
    }

    // ===== Layout Switching =====
    public async switchLayout(layout: string) {
        this.graphLayout = layout;
        await this.service.render();

        if (layout === 'circular' && this.nodes.length > 0) {
            this.renderCircularLayout();
        } else {
            this.renderGraph();
        }
    }

    private renderCircularLayout() {
        if (!this.graphContainer?.nativeElement || this.nodes.length === 0) return;

        const count = this.nodes.length;
        const radius = Math.max(200, count * 18);

        const visNodeData = this.nodes.map((n: any, i: number) => {
            const angle = (2 * Math.PI * i) / count;
            const nd = this.getNodeVisData(n);
            return { ...nd, x: radius * Math.cos(angle), y: radius * Math.sin(angle), fixed: { x: true, y: true } };
        });

        const visEdgeData = this.edges.map((e: any) => ({
            id: e.id, from: e.source_id, to: e.target_id, label: this.showEdgeLabels ? e.relation : '',
            font: { size: this.showEdgeLabels ? 10 : 0, color: '#a8a29e', strokeWidth: 0, face: 'Pretendard, sans-serif' },
            color: { color: '#d6d3d1', highlight: '#78716c', hover: '#a8a29e' },
            arrows: { to: { enabled: true, scaleFactor: 0.5 } },
            smooth: { type: 'curvedCW', roundness: 0.2 }
        }));

        this.visNodes = new DataSet(visNodeData);
        this.visEdges = new DataSet(visEdgeData);

        if (this.network) this.network.destroy();
        this.network = new Network(
            this.graphContainer.nativeElement,
            { nodes: this.visNodes, edges: this.visEdges },
            { ...this.getGraphOptions(), physics: false }
        );
        this.bindNetworkEvents();
    }

    // ===== Edge Labels =====
    public async toggleEdgeLabels() {
        this.showEdgeLabels = !this.showEdgeLabels;
        if (this.visEdges) {
            const updates = this.edges.map((e: any) => ({
                id: e.id,
                font: { size: this.showEdgeLabels ? 10 : 0, color: '#a8a29e', strokeWidth: 0, face: 'Pretendard, sans-serif' }
            }));
            this.visEdges.update(updates);
        }
        await this.service.render();
    }

    // ===== Hub Scores (Centrality) =====
    public calculateHubScores() {
        this.hubScores = {};
        for (const n of this.nodes) {
            this.hubScores[n.id] = this.getEdgeCount(n.id);
        }
    }

    public getHubScore(nodeId: string): number {
        return this.hubScores[nodeId] || 0;
    }

    public isHub(nodeId: string): boolean {
        if (this.nodes.length < 5) return false;
        const scores = Object.values(this.hubScores) as number[];
        if (scores.length === 0) return false;
        const avg = scores.reduce((a: number, b: number) => a + b, 0) / scores.length;
        return (this.hubScores[nodeId] || 0) > avg * 2;
    }

    public get topHubs(): any[] {
        return [...this.nodes]
            .sort((a: any, b: any) => (this.hubScores[b.id] || 0) - (this.hubScores[a.id] || 0))
            .slice(0, 5);
    }

    // ===== Compare Mode =====
    public async toggleCompareMode() {
        this.compareMode = !this.compareMode;
        if (!this.compareMode) {
            this.compareCollection = '';
            this.compareResult = null;
        }
        await this.service.render();
    }

    public async runCompare() {
        if (!this.selectedCollection || !this.compareCollection) return;

        const { code, data } = await wiz.call("compare_collections", {
            collection_ids: JSON.stringify([this.selectedCollection, this.compareCollection])
        });

        if (code === 200) {
            const allNodes = data.nodes || [];
            const commonLabels = new Set(data.common_labels || []);

            const colANodes = allNodes.filter((n: any) => n.collection_id === this.selectedCollection && !commonLabels.has(n.label));
            const colBNodes = allNodes.filter((n: any) => n.collection_id === this.compareCollection && !commonLabels.has(n.label));

            const seen = new Set();
            const commonNodes = allNodes.filter((n: any) => {
                if (!commonLabels.has(n.label)) return false;
                if (seen.has(n.label)) return false;
                seen.add(n.label);
                return true;
            });

            this.compareResult = {
                common: commonNodes,
                onlyA: colANodes,
                onlyB: colBNodes,
                colA: this.getCollectionTitle(this.selectedCollection),
                colB: this.getCollectionTitle(this.compareCollection)
            };
        }
        await this.service.render();
    }

    public closeCompare() {
        this.compareMode = false;
        this.compareCollection = '';
        this.compareResult = null;
    }

    // ===== Minimap =====
    public updateMinimap() {
        if (!this.network || !this.minimapCanvasRef?.nativeElement || !this.showMinimap) return;

        const canvas = this.minimapCanvasRef.nativeElement;
        const ctx = canvas.getContext('2d');
        const w = canvas.width;
        const h = canvas.height;

        ctx.clearRect(0, 0, w, h);
        ctx.fillStyle = '#fafaf9';
        ctx.fillRect(0, 0, w, h);

        const positions = this.network.getPositions();
        const nodeIds = Object.keys(positions);
        if (nodeIds.length === 0) return;

        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        for (const id of nodeIds) {
            const p = positions[id];
            if (p.x < minX) minX = p.x;
            if (p.x > maxX) maxX = p.x;
            if (p.y < minY) minY = p.y;
            if (p.y > maxY) maxY = p.y;
        }

        const pad = 10;
        const rangeX = maxX - minX || 1;
        const rangeY = maxY - minY || 1;
        const sx = (w - pad * 2) / rangeX;
        const sy = (h - pad * 2) / rangeY;
        const scale = Math.min(sx, sy);
        const ox = (w - rangeX * scale) / 2;
        const oy = (h - rangeY * scale) / 2;

        this.minimapTransform = { minX, minY, scale, ox, oy };

        // Edges
        ctx.strokeStyle = '#e7e5e4';
        ctx.lineWidth = 0.3;
        for (const e of this.edges) {
            const from = positions[e.source_id];
            const to = positions[e.target_id];
            if (from && to) {
                ctx.beginPath();
                ctx.moveTo((from.x - minX) * scale + ox, (from.y - minY) * scale + oy);
                ctx.lineTo((to.x - minX) * scale + ox, (to.y - minY) * scale + oy);
                ctx.stroke();
            }
        }

        // Nodes
        for (const n of this.nodes) {
            const p = positions[n.id];
            if (!p) continue;
            const x = (p.x - minX) * scale + ox;
            const y = (p.y - minY) * scale + oy;
            ctx.beginPath();
            ctx.arc(x, y, this.isHub(n.id) ? 3.5 : 2, 0, Math.PI * 2);
            ctx.fillStyle = this.nodeColorHex(n.node_type);
            ctx.fill();
        }

        // Viewport rectangle
        try {
            const vp = this.network.getViewPosition();
            const vs = this.network.getScale();
            const container = this.graphContainer.nativeElement;
            const vw = container.clientWidth / vs;
            const vh = container.clientHeight / vs;
            const rx = (vp.x - vw / 2 - minX) * scale + ox;
            const ry = (vp.y - vh / 2 - minY) * scale + oy;
            const rw = vw * scale;
            const rh = vh * scale;
            ctx.strokeStyle = '#3b82f6';
            ctx.lineWidth = 1;
            ctx.globalAlpha = 0.5;
            ctx.strokeRect(rx, ry, rw, rh);
            ctx.globalAlpha = 0.04;
            ctx.fillStyle = '#3b82f6';
            ctx.fillRect(rx, ry, rw, rh);
            ctx.globalAlpha = 1;
        } catch (e) { }
    }

    public onMinimapClick(event: MouseEvent) {
        if (!this.network || !this.minimapTransform || !this.minimapCanvasRef?.nativeElement) return;
        const canvas = this.minimapCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        const cx = event.clientX - rect.left;
        const cy = event.clientY - rect.top;
        const { minX, minY, scale, ox, oy } = this.minimapTransform;
        const graphX = (cx - ox) / scale + minX;
        const graphY = (cy - oy) / scale + minY;
        this.network.moveTo({ position: { x: graphX, y: graphY }, animation: { duration: 300 } });
    }

    public async toggleMinimap() {
        this.showMinimap = !this.showMinimap;
        await this.service.render();
        if (this.showMinimap) {
            setTimeout(() => this.updateMinimap(), 100);
        }
    }

    // ===== Build Graph =====
    public async buildGraph() {
        if (!this.selectedCollection) {
            await this.service.modal.show({ title: '알림', message: '자료함을 선택해주세요.', action: '확인', cancel: false });
            return;
        }

        this.building = true;
        this.buildMessage = '관계지도 생성을 시작합니다...';
        this.buildElapsed = 0;
        this.buildProgress = '';
        this.buildProgressPct = 0;
        this.buildNodeCount = 0;
        this.buildEdgeCount = 0;
        this.graphViewMode = 'graph';

        this.nodes = [];
        this.edges = [];
        this.initEmptyGraph();
        await this.service.render();

        const types = Object.keys(this.extractTypes).filter(k => this.extractTypes[k]);
        const { code, data } = await wiz.call("build_graph", {
            collection_id: this.selectedCollection,
            types: JSON.stringify(types)
        });

        if (code !== 200) {
            this.building = false;
            this.buildMessage = '';
            await this.service.modal.show({
                title: '관계지도 생성 실패',
                message: data?.message || '오류가 발생했습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
            await this.service.render();
            return;
        }

        const MAX_WAIT = 600;
        const POLL_INTERVAL = 2000;
        let elapsed = 0;
        let lastNodeCount = 0;
        let lastEdgeCount = 0;

        while (this.building && elapsed < MAX_WAIT) {
            await new Promise(r => setTimeout(r, POLL_INTERVAL));
            elapsed += POLL_INTERVAL / 1000;

            const res: any = await wiz.call("build_status", { collection_id: this.selectedCollection });
            let rcode = res?.code;
            let rdata = res?.data;
            if (res?.responseJSON) {
                rcode = res.responseJSON.code;
                rdata = res.responseJSON.data;
            }

            if (rcode !== 200) continue;

            const { build_status, phase, error, node_count, edge_count,
                    total_chunks, completed_chunks, elapsed: serverElapsed } = rdata;

            this.buildElapsed = serverElapsed || Math.round(elapsed);
            this.buildNodeCount = node_count || 0;
            this.buildEdgeCount = edge_count || 0;

            if (total_chunks > 0) {
                this.buildProgress = `${completed_chunks}/${total_chunks}`;
                this.buildProgressPct = Math.round((completed_chunks / total_chunks) * 100);
            }

            if (node_count !== lastNodeCount || edge_count !== lastEdgeCount) {
                lastNodeCount = node_count;
                lastEdgeCount = edge_count;
                await this.refreshGraphLive();
            }

            if (build_status === 'completed') {
                this.buildMessage = phase || '완료!';
                this.buildProgressPct = 100;
                await this.service.render();
                break;
            }

            if (build_status === 'error') {
                this.building = false;
                this.buildMessage = '';
                this.buildProgress = '';
                this.buildProgressPct = 0;
                await this.service.modal.show({
                    title: '관계지도 생성 실패',
                    message: error || '알 수 없는 오류가 발생했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'error'
                });
                await this.service.render();
                return;
            }

            this.buildMessage = phase || `AI 분석 중... (${this.buildElapsed}초 경과)`;
            await this.service.render();
        }

        if (elapsed >= MAX_WAIT && this.building) {
            this.building = false;
            this.buildMessage = '';
            this.buildProgress = '';
            this.buildProgressPct = 0;
            if (this.nodes.length > 0) {
                await this.service.modal.show({
                    title: '시간 초과',
                    message: `시간이 초과되었지만, 현재까지 추출된 노드 ${this.nodes.length}개와 관계 ${this.edges.length}개가 표시되어 있습니다.`,
                    action: '확인', cancel: false
                });
            } else {
                await this.service.modal.show({
                    title: '시간 초과',
                    message: '관계지도 생성에 시간이 너무 오래 걸립니다.',
                    action: '확인', cancel: false, status: 'error'
                });
            }
            await this.service.render();
            return;
        }

        this.building = false;
        this.buildMessage = '';
        this.buildProgress = '';
        this.buildProgressPct = 0;

        await this.loadGraph();
    }

    private async refreshGraphLive() {
        const { code, data } = await wiz.call("graph_data", {
            collection_id: this.selectedCollection
        });
        if (code !== 200) return;

        const newNodes = data.nodes || [];
        const newEdges = data.edges || [];

        this.nodes = newNodes;
        this.edges = newEdges;
        this.reviewCount = data.review_count || 0;
        this.calculateHubScores();

        if (!this.visNodes || !this.visEdges) {
            this.initEmptyGraph();
        }

        const currentNodeIds = new Set(this.visNodes.getIds());
        const currentEdgeIds = new Set(this.visEdges.getIds());

        const nodesToAdd: any[] = [];
        for (const n of newNodes) {
            if (!currentNodeIds.has(n.id)) {
                nodesToAdd.push(this.getNodeVisData(n, 8));
            }
        }
        const addedNodeIds = new Set(nodesToAdd.map((n: any) => n.id));

        const edgesToAdd: any[] = [];
        for (const e of newEdges) {
            if (!currentEdgeIds.has(e.id)) {
                edgesToAdd.push({
                    id: e.id, from: e.source_id, to: e.target_id, label: this.showEdgeLabels ? e.relation : '',
                    font: { size: this.showEdgeLabels ? 10 : 0, color: '#a8a29e', strokeWidth: 0, face: 'Pretendard, sans-serif' },
                    color: { color: '#d6d3d1', highlight: '#78716c', hover: '#a8a29e' },
                    arrows: { to: { enabled: true, scaleFactor: 0.5 } },
                    smooth: { type: 'continuous' }
                });
            }
        }

        if (nodesToAdd.length > 0) this.visNodes.add(nodesToAdd);
        if (edgesToAdd.length > 0) this.visEdges.add(edgesToAdd);

        const existingNodeUpdates: any[] = [];
        for (const n of newNodes) {
            if (addedNodeIds.has(n.id)) continue;
            const edgeCount = this.getEdgeCount(n.id);
            existingNodeUpdates.push({ id: n.id, size: 18 + (edgeCount * 3) });
        }
        if (existingNodeUpdates.length > 0) {
            this.visNodes.update(existingNodeUpdates);
        }

        if (nodesToAdd.length > 0) {
            setTimeout(() => {
                if (!this.visNodes) return;
                const growUpdates = newNodes
                    .filter((n: any) => addedNodeIds.has(n.id))
                    .map((n: any) => {
                        const edgeCount = this.getEdgeCount(n.id);
                        return { id: n.id, size: 18 + (edgeCount * 3) };
                    });
                if (growUpdates.length > 0) {
                    this.visNodes.update(growUpdates);
                }
                if (this.network) {
                    this.network.fit({ animation: { duration: 450 }, maxZoomLevel: 1.2 });
                }
            }, 120);
        } else if (edgesToAdd.length > 0 && this.network) {
            this.network.redraw();
        }

        await this.service.render();
    }

    private getGraphOptions() {
        let physics: any;
        let layout: any = {};

        if (this.graphLayout === 'hierarchical') {
            layout = {
                hierarchical: { enabled: true, direction: 'UD', sortMethod: 'hubsize', nodeSpacing: 150, levelSeparation: 150 }
            };
            physics = { hierarchicalRepulsion: { nodeDistance: 200 }, stabilization: { iterations: 100 } };
        } else {
            physics = {
                solver: 'forceAtlas2Based',
                forceAtlas2Based: { gravitationalConstant: -40, centralGravity: 0.005, springLength: 150, springConstant: 0.08, damping: 0.4 },
                stabilization: { iterations: 200 }
            };
        }

        return {
            layout,
            physics,
            interaction: { hover: true, tooltipDelay: 200, zoomView: true, dragView: true },
            edges: { width: 1.5, selectionWidth: 2.5 },
            nodes: { borderWidth: 2, borderWidthSelected: 3 }
        };
    }

    private initEmptyGraph() {
        if (!this.graphContainer?.nativeElement) return;
        const container = this.graphContainer.nativeElement;
        this.visNodes = new DataSet([]);
        this.visEdges = new DataSet([]);

        if (this.network) this.network.destroy();
        this.network = new Network(container, { nodes: this.visNodes, edges: this.visEdges }, this.getGraphOptions());
        this.bindNetworkEvents();
    }

    private renderGraph() {
        if (!this.graphContainer?.nativeElement || this.nodes.length === 0) return;

        const visNodeData = this.nodes.map((n: any) => this.getNodeVisData(n));
        const visEdgeData = this.edges.map((e: any) => ({
            id: e.id, from: e.source_id, to: e.target_id, label: this.showEdgeLabels ? e.relation : '',
            font: { size: this.showEdgeLabels ? 10 : 0, color: '#a8a29e', strokeWidth: 0, face: 'Pretendard, sans-serif' },
            color: { color: '#d6d3d1', highlight: '#78716c', hover: '#a8a29e' },
            arrows: { to: { enabled: true, scaleFactor: 0.5 } },
            smooth: { type: 'continuous' }
        }));

        this.visNodes = new DataSet(visNodeData);
        this.visEdges = new DataSet(visEdgeData);

        if (this.network) this.network.destroy();
        this.network = new Network(
            this.graphContainer.nativeElement,
            { nodes: this.visNodes, edges: this.visEdges },
            this.getGraphOptions()
        );
        this.bindNetworkEvents();
    }

    private bindNetworkEvents() {
        if (!this.network) return;

        this.network.on('click', async (params: any) => {
            if (params.nodes.length > 0) {
                if (this.mergeMode && this.mergeTarget) {
                    const targetNodeId = params.nodes[0];
                    if (targetNodeId !== this.mergeTarget.id) {
                        await this.confirmMerge(targetNodeId);
                    }
                    return;
                }
                await this.selectNodeFromGraph(params.nodes[0]);
            } else {
                if (this.selectedNode && this.focusMode) {
                    this.clearFocusMode();
                }
                this.selectedNode = null;
                this.connectedEdges = [];
                this.nodeDocs = [];
                this.highlightType = '';
                await this.service.render();
            }
        });

        this.network.on('doubleClick', async (params: any) => {
            if (params.nodes.length > 0) {
                this.service.href(`/collections/${this.selectedCollection}`);
            }
        });

        this.network.on('afterDrawing', () => {
            if (this.minimapTimeout) clearTimeout(this.minimapTimeout);
            this.minimapTimeout = setTimeout(() => this.updateMinimap(), 100);
        });
    }

    public getEdgeCount(nodeId: string): number {
        return this.edges.filter((e: any) => e.source_id === nodeId || e.target_id === nodeId).length;
    }

    // ===== Node Helpers =====
    public nodeColor(type: string) {
        const map: any = { 'person': 'bg-blue-300', 'place': 'bg-emerald-300', 'event': 'bg-rose-300', 'date': 'bg-violet-300' };
        return map[type] || 'bg-stone-300';
    }

    public nodeColorHex(type: string) {
        const map: any = { 'person': '#93c5fd', 'place': '#6ee7b7', 'event': '#fda4af', 'date': '#c4b5fd' };
        return map[type] || '#d6d3d1';
    }

    public nodeColorLight(type: string) {
        const map: any = {
            'person': 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
            'place': 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
            'event': 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
            'date': 'bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300'
        };
        return map[type] || 'bg-stone-50 text-stone-600';
    }

    public nodeTypeName(type: string) {
        const map: any = { 'person': '인물', 'place': '장소', 'event': '사건', 'date': '날짜' };
        return map[type] || type;
    }

    public nodeTypeIcon(type: string): string {
        const map: any = {
            'person': 'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z',
            'place': 'M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z',
            'event': 'M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z',
            'date': 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5'
        };
        return map[type] || '';
    }

    public async toggleExtractType(type: string) {
        this.extractTypes[type] = !this.extractTypes[type];
        this.applyAllFilters();
        await this.service.render();
    }

    public getCollectionTitle(id: string) {
        const col = this.collections.find((c: any) => c.id === id);
        return col ? col.title : '';
    }

    // ===== Node Selection =====
    public async askAIAboutNode() {
        if (!this.selectedNode) return;
        const label = this.selectedNode.label || '';
        const nodeType = this.nodeTypeName(this.selectedNode.node_type);
        const question = `"${label}"(${nodeType})에 대해 자세히 알려주세요.`;
        this.chatInput = question;
        this.rightTab = 'chat';
        this.updateChatExamples();
        await this.service.render();
        await this.sendChat();
    }

    public deselectNode() {
        if (this.focusMode) this.clearFocusMode();
        this.selectedNode = null;
        this.connectedEdges = [];
        this.nodeDocs = [];
        this.editingNode = false;
        if (this.network) this.network.unselectAll();
    }

    public async switchTab(tab: string) {
        this.rightTab = tab;
        if (tab === 'chat') this.updateChatExamples();
        await this.service.render();
    }

    public async focusNode(nodeId: string) {
        if (this.graphViewMode !== 'graph') {
            this.graphViewMode = 'graph';
            await this.service.render();
            await new Promise(r => setTimeout(r, 200));
            this.renderGraph();
            await new Promise(r => setTimeout(r, 200));
        }

        if (this.network) {
            this.network.focus(nodeId, { scale: 1.5, animation: { duration: 500 } });
            this.network.selectNodes([nodeId]);
        }
        const node = this.nodes.find((n: any) => n.id === nodeId);
        if (node) {
            this.highlightType = '';
            this.selectedNode = node;
            this.rightTab = 'detail';
            this.editingNode = false;
            if (this.panelCollapsed) this.panelCollapsed = false;
            this.connectedEdges = this.edges.filter((e: any) =>
                e.source_id === nodeId || e.target_id === nodeId
            ).map((e: any) => {
                const otherNodeId = e.source_id === nodeId ? e.target_id : e.source_id;
                const otherNode = this.nodes.find((n: any) => n.id === otherNodeId);
                return { ...e, otherLabel: otherNode?.label || '?', otherType: otherNode?.node_type || '' };
            });

            if (this.focusMode) this.applyFocusMode(nodeId);

            this.updateChatExamples();
            await this.loadNodeDocuments(nodeId);
            await this.service.render();
        }
    }

    private async loadNodeDocuments(nodeId: string) {
        this.nodeDocsLoading = true;
        this.nodeDocs = [];
        await this.service.render();

        const { code, data } = await wiz.call("node_documents", {
            collection_id: this.selectedCollection,
            node_id: nodeId
        });

        if (code === 200) {
            this.nodeDocs = data.documents || [];
        }
        this.nodeDocsLoading = false;
        await this.service.render();
    }

    public async selectNodeFromGraph(nodeId: string) {
        await this.focusNode(nodeId);
    }

    // ===== Chat (Contextual) =====
    private updateChatExamples() {
        if (this.selectedNode) {
            this.chatExamples = [
                `'${this.selectedNode.label}'에 대해 더 자세히 알려줘`,
                `'${this.selectedNode.label}'과 관련된 주요 사건은?`,
                `'${this.selectedNode.label}'이 언급된 문서의 핵심 내용은?`
            ];
        } else {
            const title = this.getCollectionTitle(this.selectedCollection) || '이 자료함';
            this.chatExamples = [
                `${title}에서 가장 많이 언급된 지명은?`,
                '두 문서의 공통 주제는 무엇인가요?',
                '핵심 인물 간의 관계를 설명해줘'
            ];
        }
    }

    private chatAbortController: AbortController | null = null;

    private renderChatMarkdown(text: string): string {
        if (!text) return '';

        let html = text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/^### (.+)$/gm, '<h4>$1</h4>')
            .replace(/^## (.+)$/gm, '<h3>$1</h3>')
            .replace(/^# (.+)$/gm, '<h3>$1</h3>')
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/`([^`]+)`/g, '<code>$1</code>')
            .replace(/^- (.+)$/gm, '<li>$1</li>')
            .replace(/^(\d+)\. (.+)$/gm, '<li>$2</li>');

        html = html.replace(/(<li>.*?<\/li>\n?)+/g, (match) => `<ul>${match}</ul>`);
        html = html.replace(/\n/g, '<br>');
        return html;
    }

    public async sendChat() {
        const query = this.chatInput?.trim();
        if (!query || !this.selectedCollection || this.chatLoading) return;
        const requestId = `graph-chat-${Date.now()}`;
        const startedAt = Date.now();

        // 이전 스트림 취소
        if (this.chatAbortController) {
            this.chatAbortController.abort();
            this.chatAbortController = null;
        }

        this.chatMessages.push({ role: 'user', content: query });
        this.chatInput = '';
        this.chatLoading = true;
        await this.service.render();
        this.scrollChatToBottom();

        const assistantMsg: any = { role: 'assistant', content: '질문을 분석하고 있습니다...', streaming: true };
        this.chatMessages.push(assistantMsg);
        await this.service.render();

        const abortController = new AbortController();
        this.chatAbortController = abortController;

        try {
            const formData = new FormData();
            formData.append('query', query);
            formData.append('collection_id', this.selectedCollection);

            console.log('[page.graph chat] request:start', {
                requestId,
                collectionId: this.selectedCollection,
                query
            });

            const response = await fetch(wiz.url('stream_chat'), {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'text/event-stream'
                },
                credentials: 'same-origin',
                signal: abortController.signal
            });

            console.log('[page.graph chat] response:open', {
                requestId,
                status: response.status,
                elapsedMs: Date.now() - startedAt
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            if (!response.body) {
                throw new Error('Empty response body');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let fullContent = '';
            let lastRenderTime = 0;
            let firstTokenLogged = false;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const parts = buffer.split('\n\n');
                buffer = parts.pop() || '';

                for (const part of parts) {
                    const line = part.trim();
                    if (!line.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(line.slice(6));
                        if (event.type === 'token') {
                            if (!firstTokenLogged) {
                                console.log('[page.graph chat] stream:first-token', {
                                    requestId,
                                    elapsedMs: Date.now() - startedAt
                                });
                                firstTokenLogged = true;
                            }
                            fullContent += event.token;
                            assistantMsg.content = fullContent;
                        } else if (event.type === 'status') {
                            console.log('[page.graph chat] stream:status', {
                                requestId,
                                message: event.message,
                                elapsedMs: Date.now() - startedAt
                            });
                            if (!fullContent) {
                                assistantMsg.content = event.message || assistantMsg.content;
                            }
                        } else if (event.type === 'done') {
                            console.log('[page.graph chat] stream:done', {
                                requestId,
                                elapsedMs: Date.now() - startedAt,
                                outputLength: fullContent.length
                            });
                            assistantMsg.streaming = false;
                        } else if (event.type === 'error') {
                            console.error('[page.graph chat] stream:error', {
                                requestId,
                                message: event.message,
                                elapsedMs: Date.now() - startedAt
                            });
                            assistantMsg.streaming = false;
                            assistantMsg.content = event.message || '오류가 발생했습니다.';
                        }
                    } catch (e) { }
                }

                // 80ms 간격으로 렌더링
                const now = Date.now();
                if (now - lastRenderTime > 80) {
                    lastRenderTime = now;
                    await this.service.render();
                    this.scrollChatToBottom();
                }
            }

            // 남은 buffer 처리
            if (buffer.trim()) {
                const line = buffer.trim();
                if (line.startsWith('data: ')) {
                    try {
                        const event = JSON.parse(line.slice(6));
                        if (event.type === 'token') {
                            fullContent += event.token;
                            assistantMsg.content = fullContent;
                        } else if (event.type === 'status') {
                            console.log('[page.graph chat] stream:status-tail', {
                                requestId,
                                message: event.message,
                                elapsedMs: Date.now() - startedAt
                            });
                            if (!fullContent) {
                                assistantMsg.content = event.message || assistantMsg.content;
                            }
                        } else if (event.type === 'done') {
                            assistantMsg.streaming = false;
                        }
                    } catch (e) { }
                }
            }

            assistantMsg.streaming = false;
            if (!assistantMsg.content) {
                assistantMsg.content = '답변을 생성할 수 없습니다.';
            }
            assistantMsg.html = this.renderChatMarkdown(assistantMsg.content);
        } catch (e: any) {
            console.error('[page.graph chat] request:failed', {
                requestId,
                name: e?.name,
                message: e?.message,
                elapsedMs: Date.now() - startedAt
            });
            assistantMsg.streaming = false;
            if (e?.name !== 'AbortError') {
                assistantMsg.content = assistantMsg.content || '응답을 가져올 수 없습니다.';
            } else if (!assistantMsg.content) {
                assistantMsg.content = '요청이 취소되었습니다.';
            }
            assistantMsg.html = this.renderChatMarkdown(assistantMsg.content);
        } finally {
            console.log('[page.graph chat] request:end', {
                requestId,
                elapsedMs: Date.now() - startedAt,
                finalLength: (assistantMsg.content || '').length
            });
            if (this.chatAbortController === abortController) {
                this.chatAbortController = null;
            }
            this.chatLoading = false;
            await this.service.render();
            this.scrollChatToBottom();
        }
    }

    public async onChatKeydown(event: any) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            await this.sendChat();
        }
    }

    public async useExampleChat(q: string) {
        this.chatInput = q;
        await this.sendChat();
    }

    private scrollChatToBottom() {
        setTimeout(() => {
            if (this.chatMessagesContainer) {
                const el = this.chatMessagesContainer.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 100);
    }

    public confidencePct(val: number): number {
        return Math.round((val || 0) * 100);
    }
}

export default PageGraphComponent;